import React, {Component} from 'react';
import MetaTags from 'react-meta-tags';
import {
    NavLink
} from "react-router-dom";

// Data
import Data from '../../data/Themes.json';

// Containers
import ContentHeader from '../../containers/ContentHeader/ContentHeader';
import Hero from '../../containers/Hero/Hero';
import HeroLayer from '../../containers/Hero/HeroLayer';

// Components
import Anime from '../../components/Anime/Anime';

class PageSupport extends Component {



    render () {

    	let themes = Data.themes;

        return (
            <div className="app-section mb-sm">
                <MetaTags>
                    <title>Support</title>
                    <meta 
                        name="description" 
                        content="Need Support?" 
                    />
                </MetaTags>

                <Hero height="auto" classes="hero-page">
                	<div className="container">
		            	<ContentHeader 
		                    title="Support Center" 
		                    subTitle="What can we help you with?" 
		                    classes="" 
		                />
	                </div>
		            <HeroLayer
	                	classes="lines-bg anim anim--fade anim--duration-4 anim--delay-3"
	                	styleOuter={{
	                		zIndex:1
	                	}}
	                	styleInner={{
	                		top: 0,
	                		bottom: 0,
	                		left:0,
	                		right:0,
	                		opacity:0.6,
                    		backgroundSize: "cover",
	                		backgroundImage: "url(https://rascalsthemes.com/images/dark-texture.jpg)",
	                	}}
	                />
            	</Hero>
 				
                <div className="container">
                   

                    <div className="row row-large-gutter">
                        <div className="col-lg-7 col-md-6 col-12 mb mb-sm">
                        	<Anime type="fade-up" delay="3" duration="3">
	                            <h6><strong>Log in to your Envato account page and let us solve your problem!</strong></h6>
	                            <p>If you bought our theme and you have questions or issues then do not hesitate - log in and create a ticket with a complete description of your problem and our support team will investigate it and get back to you as soon as it's possible.</p>
	                            <p>
	                                Rascals Themes office is located in Poland (EU) and our working hours are 8:00AM to 4:00PM (GMT +1) on workdays (Monday to Friday excluding public holidays). Please be mindful of potentially slower response times due to time difference. Our premium support is available to registered members only.
	                            </p>
	                            <h6><strong>Select product:</strong></h6>
	                            <ul className="support-links">
                                 	{
					                	themes.map((theme, i) => {
											return (
												<li key={i}>
													<a href={ `${theme.shopLink}/support` } target="_blank">{theme.theme} </a>
												</li>
											);
										})
				                	}
	                            </ul>
                            </Anime>
                        </div>

                        <div className="col-lg-5 col-md-6 col-12 mb mb-sm">
                        	<Anime type="fade" delay="5" duration="4">
	                            <div className="tips-box">
	                                <h6><strong>Before you ask</strong></h6>
	                                <ol>
	                                    <li>Please read our <NavLink to="/support-policy">support policy</NavLink></li>
	                                    <li>Make sure you're running the latest version of WordPress.</li>
	                                    <li>Make sure you're running the latest version of the theme and plugins.</li>
	                                    <li>Disable any additional 3rd party plugins you may be using to see if it fixes the issue.</li>
	                                    <li>Make sure you're using an unmodified version of the theme.</li>
	                                    <li>Make sure that all of your customizations are placed in child theme.</li>
	                                    <li>Check our <NavLink to="/faq">FAQ</NavLink> for answers to common problems.</li>
	                                </ol>

	                            </div>
	                        </Anime>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default PageSupport;


// WEBPACK FOOTER //
// ./src/pages/PageSupport/PageSupport.js